module.exports = __webpack_public_path__ + "static/nanogirlPodcast-decee843baecf4e5719cfd0b5924c525.jpg";